import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api, API } from "@/lib/api";
import { FileDown, FileText } from "lucide-react";

export const Reports = () => {
  const { data } = useQuery({ queryKey: ["reports"], queryFn: async () => (await api.get("/reports/catalogue")).data });
  const items = data || [];

  return (
    <div className="space-y-6" data-testid="page-reports">
      <header>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#7C93A5]">Reporting360™</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Enterprise Reports</h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">Government-quality PDF and Excel reports — sealed with the Cadastre360™ demonstration watermark.</div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((r) => (
          <div key={r.id} className="cad-panel p-5" data-testid={`report-${r.id}`}>
            <div className="flex items-start justify-between">
              <div className="w-10 h-10 rounded-sm cad-glass flex items-center justify-center">
                <FileText size={20} className="text-[#C99A2E]"/>
              </div>
              <span className="cad-chip cad-chip-gold">{r.format}</span>
            </div>
            <div className="font-display font-bold text-[#F6F8FA] mt-3">{r.title}</div>
            <div className="text-[13px] text-[#B3C2CC] mt-1 leading-relaxed">{r.description}</div>
            <a href={`${API.replace(/\/api$/, "")}${r.url}`} target="_blank" rel="noopener noreferrer"
               data-testid={`download-${r.id}`}
               className="cad-btn-primary mt-4 px-4 py-2 rounded-sm text-[13px] inline-flex items-center gap-2">
              <FileDown size={14}/> Download
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
